import { useEventDate } from '@/hooks/utils/useEventDate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faPlay } from '@fortawesome/free-solid-svg-icons'
import { CardEventInfo } from '@/components/Cards/utils/CardEventInfo'
import { useImage } from '@/hooks/images/useImage'
import { useTranslation } from '@/localization/useTranslation'
import { Tooltip } from '@/components/Tooltip'
import { IPlaylistItem } from '@/types'
import { NextImage } from '@/components/NextImage'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface HorizontalCardProps {
  item: IPlaylistItem
  imageCut?: string
  handleCardClick?: (item: IPlaylistItem) => void
  isPlaceholder?: boolean
  isLocked?: boolean
}

export const HorizontalCard = (props: HorizontalCardProps) => {
  const {
    item,
    handleCardClick = () => null,
    imageCut = 'backdrop',
    isPlaceholder,
    isLocked = false,
  } = props
  const { t } = useTranslation()
  const title = t(item?.title)
  const event = item?.__belong?.Event
  const canPlay = !!item?.videos?.length
  const isLiveChannel = item?.isLiveChannel

  const { date, isPast, isLive } = useEventDate({
    event: event,
    format: 'full-date-time',
  })
  const { url: image } = useImage({ images: item?.images, cut: imageCut, scale: '75' })
  const hasDate = isPast || isLive || isPlaceholder
  const displayDate = isPlaceholder ? '__placeholder__' : date
  const displayTitle = isPlaceholder ? '__placeholder__' : title

  return (
    <div className={classes.card} onClick={() => handleCardClick(item)}>
      <div className={classes.body}>
        <div className={classNames({
          [classes.body__content]: true,
          [classes['body__content--can-play']]: canPlay,
          [classes['body__content--placeholder']]: isPlaceholder,
        })}>
          <NextImage
            alt={title}
            fill={true}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 20vw"
            src={image}
            priority
          />
          <CardEventInfo event={event} isLocked={isLocked} isLiveChannel={isLiveChannel} />
        </div>
        <Overlay isLocked={isLocked} canPlay={canPlay} />
      </div>
      <div className={classNames({
        [classes.title]: true,
        [classes['title--placeholder']]: isPlaceholder
      })}>
        <Tooltip
          text={displayTitle}
          position="bottom"
          disabled={isPlaceholder}
        >
          <h3>{displayTitle}</h3>
        </Tooltip>
        {(hasDate && !isLiveChannel) &&
          <h4>
            {displayDate}
          </h4>
        }
      </div>
    </div>
  )
}

const Overlay = ({ isLocked, canPlay }: { isLocked: boolean, canPlay: boolean }) => {
  if (!canPlay && !isLocked) return null

  return (
    <div className={classNames({ [classes.overlay]: true })}>
      {isLocked ?
        <FontAwesomeIcon icon={faLock} size={'2x'} /> :
        <FontAwesomeIcon icon={faPlay} size={'2x'} />
      }
    </div>
  )
}